import { address } from "/apollo/client/local";
import { AddressStorageKey } from "/apollo/client/local/address/address.types";
import { formatAddress, geoCode } from "/geoservice";

export const initializeAddress = (
  address1?: string | null,
  city?: string | null,
  state?: string | null,
  zipCode?: string | null,
) => {
  if (!localStorage.getItem(AddressStorageKey) && address1 && city && state && zipCode) {
    geoCode({ address1, city, state, zipCode }, (result) => {
      if (result) {
        address.update(formatAddress(result[0]));
      }
    });
  }
};
